import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import React, {Component} from "react";

class Loader extends Component {


    render() {
        return (
            <div style={{
                display: this.props.loaded ? "none" : "flex",
                width: "100vw",
                justifyContent: "center",
                marginTop: "20vh"
            }}>
                <CircularProgress size={100} thickness={2}/>
            </div>
        );
    }

}


export default Loader;
